module.exports = __webpack_public_path__ + "static/media/list.e68bddcb.svg";